import { render } from "./DockLeft.vue?vue&type=template&id=7b11c554"
import script from "./DockLeft.vue?vue&type=script&lang=js"
export * from "./DockLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DockLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b11c554"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b11c554', __exports__)) {
    api.reload('7b11c554', __exports__)
  }
  
  module.hot.accept("./DockLeft.vue?vue&type=template&id=7b11c554", () => {
    api.rerender('7b11c554', render)
  })

}


export default __exports__